/**
 * @generated SignedSource<<b3832534a57b6efb7955ae4243eead82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CoverImageKind = "UPLOAD" | "URL" | "%future added value";
export type SpacesUpdateShortcutMutationInput = {
  clientMutationId?: string | null;
  coverImage?: CoverImageInput | null;
  id: string;
  title?: string | null;
  url?: string | null;
};
export type CoverImageInput = {
  kind: CoverImageKind;
  value: string;
};
export type ManageSpaceShortcutModal_updateSpaceShortcut_Mutation$variables = {
  input: SpacesUpdateShortcutMutationInput;
};
export type ManageSpaceShortcutModal_updateSpaceShortcut_Mutation$data = {
  readonly updateSpaceShortcut: {
    readonly shortcutUpdated: {
      readonly coverImage: {
        readonly name: string | null;
        readonly url: URIString;
      };
      readonly id: string;
      readonly title: string;
      readonly url: URIString;
    };
  } | null;
};
export type ManageSpaceShortcutModal_updateSpaceShortcut_Mutation = {
  response: ManageSpaceShortcutModal_updateSpaceShortcut_Mutation$data;
  variables: ManageSpaceShortcutModal_updateSpaceShortcut_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SpacesUpdateShortcutMutationPayload",
    "kind": "LinkedField",
    "name": "updateSpaceShortcut",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SpaceShortcut",
        "kind": "LinkedField",
        "name": "shortcutUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CoverImage",
            "kind": "LinkedField",
            "name": "coverImage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ManageSpaceShortcutModal_updateSpaceShortcut_Mutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ManageSpaceShortcutModal_updateSpaceShortcut_Mutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0a3dfb04a048bee21f26eb85ebe58eb8",
    "id": null,
    "metadata": {},
    "name": "ManageSpaceShortcutModal_updateSpaceShortcut_Mutation",
    "operationKind": "mutation",
    "text": "mutation ManageSpaceShortcutModal_updateSpaceShortcut_Mutation(\n  $input: SpacesUpdateShortcutMutationInput!\n) {\n  updateSpaceShortcut(input: $input) {\n    shortcutUpdated {\n      id\n      title\n      url\n      coverImage {\n        name\n        url\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d618640e2f5485899f895df72b7549c4";

export default node;
